import { Component, HostListener } from '@angular/core';
import { FormControl, Validators, ReactiveFormsModule, ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { AgenxCardComponent } from '../../ds/atoms/card/card.component';
import { AgenxInputComponent } from '../../ds/atoms/input/input.component';
import { AgenxHeaderComponent } from '../../ds/moleculs/header/header.component';
import { AgenxCardCreateComponent } from '../../ds/moleculs/card-create/card-create.component';
import { AgenxSelectComponent } from '../../ds/atoms/select/select.component';
import { AgenxTextareaComponent } from '../../ds/atoms/textarea/textarea.component';
import { AgenxTableComponent } from '../../ds/atoms/table/table.component';
import { AgenxButtonComponent } from '../../ds/atoms/button/button.component';
import { AgenxAlertComponent } from '../../ds/atoms/alert/alert.component';
import { AgenxAlertRadioComponent } from '../../ds/moleculs/alert-radio/alert-radio.component';
import { AgenxRadioComponent } from '../../ds/atoms/radio/radio.component';
import { AgenxCardSubComponent } from '../../ds/organism/card-sub/card-sub.component';
import { AgenxInputImgComponent } from '../../ds/atoms/input-img/input-img.component';
import { AgenxPaginatorComponent } from '../../ds/atoms/paginator/paginator.component';
import { AgenxSignatureComponent } from '../../ds/organism/signature/signature.component';

import { AccountService } from '../../../services/account.service';
import { GaugingService } from '../../../services/gauging.service';

import { Operator, PaymentMethod, Reason, TypeBilling, Vehicle} from '../../../interfaces/create-edit.interface';
import { CardContent, GaugingFull, Residue, SpecialGauge } from '../../../interfaces/gauging.interface';
import { Router } from '@angular/router';
import { Signs, SubsData} from '../../../interfaces/person.interface';
import { Subscription, first, forkJoin} from 'rxjs';
import { ToastService } from '../../../services/toast.service';
import { OfflineService } from '../../../services/offline.service';
import { REGEX } from '../../../utils/constants';
import { CommonModule, DecimalPipe } from '@angular/common';
import { AgenxCardGaugeComponent } from "../../ds/organism/card-gauge/card-gauge.component";
import { dateTimeToString } from '../../../utils/date-functions';
import { ObjectsService } from '../../../services/objects.service';
import { pluralize, replaceInArray } from '../../../utils/functions';
import { OperatorsComponent } from '../../ds/organism/operators/operators.component';
import { AgenxCircleButtonComponent } from "../../ds/atoms/circle-button/circle-button.component";

@Component({
  selector: 'app-create-edit',
  standalone: true,
  imports: [
    MatDialogModule,
    AgenxSignatureComponent,
    AgenxPaginatorComponent,
    AgenxInputImgComponent,
    AgenxCardSubComponent,
    AgenxCardComponent,
    AgenxRadioComponent,
    AgenxAlertRadioComponent,
    AgenxAlertComponent,
    AgenxButtonComponent,
    AgenxTableComponent,
    AgenxTextareaComponent,
    AgenxSelectComponent,
    AgenxInputComponent,
    AgenxHeaderComponent,
    AgenxCardCreateComponent,
    ReactiveFormsModule,
    SweetAlert2Module,
    AgenxCardGaugeComponent,
    CommonModule,
    AgenxCircleButtonComponent
],
  providers: [DecimalPipe],
  templateUrl: './create-special.component.html',
  styleUrl: './create-special.component.scss',
})
export class CreateSpecialComponent {
  @HostListener('window:resize', ['$event'])
  onResize(event: { target: { innerWidth: number } }) {
    this.card_x_page = event.target.innerWidth > 1580 ? 8 : 6;
  }
  private subscriptions: Subscription[] = [];

  card_info!: CardContent;
  newEmail: FormControl = new FormControl({ value: '', disabled: false });
  photos: FormControl = new FormControl({ value: '', disabled: false });
  formAforos: Array<{ name: string; control: FormControl }> = [
    {
      name: 'category',
      control: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
    },
    {
      name: 'residue',
      control: new FormControl({ value: '', disabled: false }, [
        Validators.required,
      ]),
    },
    {
      name: 'amount',
      control: new FormControl({ value: '', disabled: false }, [
        Validators.required,
        Validators.pattern(/^\d+(\.\d{1,4})?$/),
        Validators.min(0.1),
      ]),
    },
    {
      name: 'observations',
      control: new FormControl({ value: '', disabled: false }, []),
    },
    {
      name: 'radioNoWaste',
      control: new FormControl({ value: '1', disabled: false }, [
        Validators.required,
      ]),
    },
  ];
  formPayMethod: Array<{ name: string; control: FormControl }> = [
    {
      name: 'pay_method',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'subscribed_service',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'voucher',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'installments',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'vehicle',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'type_billing',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'reason',
      control: new FormControl({ value: '', disabled: false }),
    },
    {
      name: 'observations_gen',
      control: new FormControl({ value: '', disabled: false }),
    },
  ];
  gauging_data!: GaugingFull | null;
  gauges: Array<SpecialGauge> = [];
  categories: Array<{ value: number; label: string }> = [];
  residuesCat: Array<{ value: number; label: string }> = [];
  payOptions: Array<{ value: number; label: string }> = [];
  vehOptions: Array<{ value: number; label: string }> = [];
  reasonOptions: Array<{ value: number; label: string }> = [];
  typesBilOptions: Array<{ value: number; label: string }> = [];
  residues: Array<Residue> = [];
  payMethods: Array<PaymentMethod> = [];
  vehicles: Array<Vehicle> = [];
  typesBilling: Array<TypeBilling> = [];
  reasons: Array<Reason> = [];
  operators: Array<Operator> = [];
  tablePrice = [{ td: ['0', '$0'] }, { td: ['x', '$yyy'] }];

  cards_content: CardContent[] = [];
  data_form!: SubsData;
  files: Array<any> = [];
  btn_add = 'Agregar';
  selectedWaste = '';
  cards_page: CardContent[] = [];
  pages: number[] = [];
  pageSelected: number = 1;
  newPage: boolean = true;
  card_x_page = 8;
  card_selected: SpecialGauge | null = null;
  load_evidences: Array<{ name: string; file: string }> = [];
  signatureImg: string | null = '';
  error_sign_flume = false;
  signatureImgSub: string | null = '';
  error_sign_sub = false;
  save_btn: 'loading' | 'normal' = 'normal';
  loading = false;
  showCancel = false;
  no_internet = false;
  gaugings_pend: Array<any> = [];
  icon_delete_src = '';
  icon_edit_src = '';
  vehicleSel: Vehicle | undefined;
  residueSel: Residue | undefined;
  payMethodSel: PaymentMethod | undefined;
  total = 0;
  showForm = false;
  needSubsService = false;
  needVoucher = false;
  needInstallments = false;
  noWaste = false;
  iconAdd = ''

  constructor(
    private accountSrv: AccountService,
    private decimalPipe: DecimalPipe,
    public dialog: MatDialog,
    private gaugingSrv: GaugingService,
    private objectsSrv: ObjectsService,
    private offlineSrv: OfflineService,
    public router: Router,
    private toastSrv: ToastService
  ) {}

  /**
   * Permanently deletes a file and provides user feedback.
   *
   * @param {any} file_del - The file object to be deleted.
   * @returns {void}
   */
  deletePermanentFile(file_del: any): void {
    this.subscriptions.push(
      this.gaugingSrv
        .deleteFile(file_del.id)
        .pipe(first())
        .subscribe({
          next: () => {
            this.toastSrv.success('La imagen fue eliminada correctamente.');
          },
          error: (error: { error: { detailed: string } }) => {
            let message = error.error.hasOwnProperty('detailed')
              ? error.error.detailed
              : 'No se pudo eliminar el archivo.';
            this.no_internet &&
              (message += ' No cuenta con una conexión estable a internet.');
            this.toastSrv.error(message);
          },
        })
    );
  }

  /**
   * Deletes the signature image based on the specified type.
   *
   * @param {string} type - The type of signature to delete ('sub' or other).
   * @returns {void}
   */
  deleteSignature(type: string): void {
    if (type === 'sub') {
      this.signatureImgSub = '';
    } else {
      this.signatureImg = '';
    }
  }

  /**
   * Opens the dialog to edit the signature based on the specified type.
   *
   * @param {string} type - The type of signature to edit ('sub' or other).
   * @returns {void}
   */
  editSignature(type: string): void {
    if (type === 'sub') {
      this.openDialogSignature('sub');
    } else {
      this.openDialogSignature('');
    }
  }

  /**
   * Gets the FormControl object for the specified form field.
   *
   * @param {string} field - The name of the form field.
   * @returns {FormControl} - The FormControl object associated with the field.
   */
  getControlOf(field: string): FormControl {
    let i = this.formAforos.findIndex((ele) => ele.name === field);
    return this.formAforos[i].control;
  }

  getCtrlPayForm(field: string): FormControl {
    let i = this.formPayMethod.findIndex((ele) => ele.name === field);
    return this.formPayMethod[i].control;
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subsciption) => subsciption.unsubscribe());
    this.offlineSrv.removeFromLocal('special_data');
  }

  ngOnInit(): void {
    this.icon_delete_src = this.offlineSrv.loadAssetInLocal('Icon_Delete.svg');
    this.icon_edit_src = this.offlineSrv.loadAssetInLocal('Icon_Edit.svg');
    this.residues = this.offlineSrv.loadFromLocal('residues', []);
    this.payMethods = this.offlineSrv.loadFromLocal('payMethods', []);
    this.typesBilling = this.offlineSrv.loadFromLocal('typesBilling', []);
    this.vehicles = this.offlineSrv.loadFromLocal('vehicles', []);
    this.reasons = this.offlineSrv.loadFromLocal('reasons', []);
    this.operators = this.offlineSrv.loadFromLocal('operators', []);
    this.signatureImg = this.offlineSrv.loadFromLocal('signatureImg');
    this.loading = true;
    this.card_info = this.offlineSrv.loadFromLocal('special_data');
    !this.card_info && this.router.navigateByUrl('/dashboard');
    let person = this.card_info.subscriber || this.card_info.client;
    this.data_form = {
      name: person?.name ?? '---',
      niud: 'niud' in person! ? person.niud : '---',
      phone: person?.phone ?? '---',
      address: person?.address ?? '---',
      neighborhood: person?.neighborhood ?? '---',
      email: person?.email,
      identification: person?.identification! ?? '---',
      code: 'code' in person! ? person?.code! : '---',
    };
    this.gauges = this.card_info.metadata!.registers.map((reg) => {
      reg.id = Math.floor(10000 + Math.random() * 90000);
      return reg;
    });
    this.gauges.forEach((gau) => {
      this.total += gau.costs;
    });
    this.newEmail.addValidators(this.emailListValidator);
    this.iconAdd = this.offlineSrv.loadAssetInLocal('icon-add.svg');

    // onlineStatus$ emits the current status on subscribe; the initial load is
    // done below, so only a reconnection (offline -> online) fetches here.
    this.subscriptions.push(
      this.offlineSrv.onlineStatus$.subscribe((isOnline: boolean) => {
        const reconnected = this.no_internet && isOnline;
        this.no_internet = !isOnline;
        if (
          reconnected &&
          (this.residues.length === 0 ||
            this.payMethods.length === 0 ||
            !this.signatureImg ||
            this.typesBilling.length === 0 ||
            this.vehicles.length === 0 ||
            this.reasons.length === 0)
        ) {
          this.getInitInfo();
        }
      }),
    );

    if (this.no_internet) {
      this.initLoadInfo();
    } else {
      this.getInitInfo();
    }
  }

  /**
   * Adds a new 'Aforo' (measurement) if the form is valid.
   * Resets the form and updates the paginator.
   *
   * @returns {void}
   */
  onAddAforo(): void {
    if (!this.showForm) {
      this.showForm = true;
      return;
    }
    if (!this.formAforos.find((element) => element.control.invalid)) {
      let auxGauges = this.gauges;
      this.gauges = [];
      this.pageSelected = 0;
      let data: SpecialGauge = {
        costs: Math.round(
          Number(this.getControlOf('amount').value) * this.residueSel?.price!
        ),
        residue: this.residueSel!,
        amount: Number(this.getControlOf('amount').value),
      };
      this.getControlOf('observations').value &&
        (data.observations = this.getControlOf('observations').value);
      if (this.card_selected) {
        this.total -= auxGauges.find(
          (gau) => gau.id === this.card_selected!.id
        )!.costs;
        auxGauges = auxGauges.filter(
          (gau) => gau.id !== this.card_selected!.id
        );
        this.card_selected = null;
        this.btn_add = 'Agregar';
      }
      data.id = Math.floor(10000 + Math.random() * 90000);
      auxGauges.unshift(data);
      this.onCancel();
      this.gauges = auxGauges;
      this.total += data.costs;
      setTimeout(() => {
        this.pageSelected = 1;
      });
      this.onCancel();
    } else {
      this.formAforos.forEach((element) => element.control.markAsTouched());
    }
  }

  /**
   * Resets the form fields and updates the equivalency table.
   * Handles UI updates for the waste and gauging elements.
   *
   * @returns {void}
   */
  onCancel(): void {
    this.getControlOf('category').reset();
    this.getControlOf('residue').reset();
    this.getControlOf('amount').reset();
    this.getControlOf('observations').reset();
    this.tablePrice = [{ td: ['0', '$0'] }, { td: ['x', '$yyy'] }];
    this.showCancel = false;
    this.gauges.map((gau: SpecialGauge) => (gau.color = 'blue'));
  }

  /**
   * Handles the selection of a sub-card. If the card is to be edited, populates the form fields.
   * If the card is to be deleted, calls the deleteAforo method.
   *
   * @param {any} card - The card object that was clicked.
   * @returns {void}
   */
  onClickSubCard(card: any): void {
    this.card_selected = card.card_info;
    let residue = this.card_selected!.residue;
    this.gauges.map((gau: SpecialGauge) => {
      gau.id === this.card_selected!.id
        ? (gau.color = 'orange')
        : (gau.color = 'blue');
      return gau;
    });
    if (card.cardSubButtonType === 'Edit') {
      this.showForm = true;
      this.btn_add = 'Guardar';
      this.showCancel = true;
      let category_id = this.categories.find(
        (cat) => cat.label === residue.category
      )?.value;
      this.getControlOf('category').setValue(category_id);
      this.onSelectCategory();
      let residue_id = this.residuesCat.find(
        (res) => res.label === `${residue.description} (${residue.unit})`
      )?.value;
      this.getControlOf('residue').setValue(residue_id);
      this.getControlOf('amount').setValue(this.card_selected!.amount);
      this.showTable();
      this.getControlOf('observations').setValue(
        this.card_selected!.observations
      );
    } else {
      this.deleteAforo(this.card_selected!);
    }
  }

  onClickNoWaste(value: string): void {
    this.noWaste = value == '2';
    let reasonCtrl = this.getCtrlPayForm('reason');
    if (this.noWaste) {
      reasonCtrl.setErrors(reasonCtrl.value == '-1' ? { noValue: true } : null);
      this.getCtrlPayForm('type_billing').setValue('-1');
      this.getCtrlPayForm('pay_method').setValue('-1');
    } else {
      reasonCtrl.setErrors(null);
    }
    reasonCtrl.markAsUntouched();
    reasonCtrl.updateValueAndValidity();
    reasonCtrl.markAsTouched();
  }

  onPayMethodSel(): void {
    this.payMethodSel = this.payMethods.find(
      (pay) => pay.id == this.getCtrlPayForm('pay_method').value
    );
    if (this.card_info.client) {
      if (this.payMethodSel?.need_subs_service!) {
        this.getCtrlPayForm('subscribed_service').addValidators([
          Validators.required,
          Validators.pattern(REGEX.NUMERIC),
        ]);
        this.needSubsService = true;
        setTimeout(() => {
          this.getCtrlPayForm('subscribed_service').setValue(
            this.card_info.client?.subscribed_service
          );
        });
      } else {
        this.getCtrlPayForm('subscribed_service').clearValidators();
        this.getCtrlPayForm('subscribed_service').setValue('');
        this.needSubsService = false;
      }
    };
    if (this.payMethodSel?.need_voucher!) {
      this.getCtrlPayForm('voucher').addValidators([
        Validators.required,
        Validators.pattern(REGEX.NUMERIC),
      ]);
      this.needVoucher = true;
    } else {
      this.getCtrlPayForm('voucher').clearValidators();
      this.getCtrlPayForm('voucher').setValue('');
      this.needVoucher = false;
    };
    if (this.payMethodSel?.need_installments!) {
      this.getCtrlPayForm('installments').addValidators([
        Validators.required,
        Validators.pattern(REGEX.NUMERIC),
      ]);
      this.needInstallments = true;
    } else {
      this.getCtrlPayForm('installments').clearValidators();
      this.getCtrlPayForm('installments').setValue('');
      this.needInstallments = false;
    }
  }

  onSelectCategory(): void {
    this.residuesCat = this.residues
      .filter((w) => w.category_id == this.getControlOf('category').value)
      .map((w) => {
        return { value: w.id!, label: `${w.description} (${w.unit})` };
      });
    this.getControlOf('residue').setValue(this.residuesCat[0].value);
    this.showTable();
  }

  onVehicleSelect(): void {
    this.vehicleSel = undefined;
    let vehicleId = this.getCtrlPayForm('vehicle').value;
    if (vehicleId != -1) {
      this.vehicleSel = this.vehicles.find((veh) => veh.id == vehicleId);
    }
  }

  /**
   * Opens a dialog for capturing a signature and updates the signature image based on the type.
   *
   * @param {string} type - The type of signature ('sub' or other).
   * @returns {void}
   */
  openDialogSignature(type: string): void {
    const dialogRef = this.dialog.open(AgenxSignatureComponent, {
      disableClose: true,
      data: { type },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (type === 'sub') {
        result.signature && (this.signatureImgSub = result.signature);
      } else {
        result.signature && (this.signatureImg = result.signature);
      }
    });
  }

  openDialogOperators(): void {
    const dialogRef = this.dialog.open(OperatorsComponent, {
      disableClose: true,
      data: {operators: this.operators, vehicle_id: this.vehicleSel?.id}
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.vehicles = replaceInArray(this.vehicles, 'id', result.id, result)!;
        this.getCtrlPayForm('vehicle').setValue(result.id);
        this.onVehicleSelect()
      }
    });
  }

  /**
   * Deletes an 'Aforo' (measurement) after confirmation from the user.
   * Updates the aforosContent and cards_content arrays and the paginator.
   *
   * @param {number} index - The index of the 'Aforo' to be deleted.
   * @returns {void}
   * @private
   */
  private deleteAforo(gauge: SpecialGauge): void {
    let text = `¿Está seguro de eliminar este aforo?`;
    Swal.fire({
      title: 'Eliminar aforo',
      html: text,
      icon: 'warning',
      confirmButtonColor: '#e64544',
      cancelButtonColor: '#8b8b8c',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
    }).then((result: any) => {
      Swal.hideLoading();
      if (result.isConfirmed) {
        let auxGauges = this.gauges.filter((gau) => gau.id !== gauge.id);
        let prevPage = this.pageSelected;
        this.gauges = [];
        this.pageSelected = 0;
        this.gauges = auxGauges;
        this.total -= gauge.costs;
        this.showCancel = false;
        setTimeout(() => {
          this.setPaginator(prevPage);
        });
        this.onCancel();
      }
    });
  }

  private emailListValidator: ValidatorFn = (
    control: AbstractControl
  ): ValidationErrors | null => {
    const email = control.value as string;

    if (!email) {
      return null; // No value, no errors
    }

    const trimmedEmail = email.replace(/\s+/g, '');
    const emailList = trimmedEmail.split(';');
    const pattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;

    for (const email of emailList) {
      if (!pattern.test(email)) {
        return { invalidEmailFormat: 'Correo con formato incorrecto.' };
      }
    }

    return null;
  };

  private getInitInfo(): void {
    this.subscriptions.push(
      forkJoin([
        this.objectsSrv.getResidues(),
        this.objectsSrv.getSigns(
          this.data_form.niud,
          this.accountSrv.userValue?.username!
        ),
        this.objectsSrv.getPaymentMethods(),
        this.objectsSrv.getTypesBilling(),
        this.objectsSrv.getVehicles(),
        this.objectsSrv.getReasons(),
        this.objectsSrv.getOperators(),
      ]).subscribe({
        next: ([residues, signs, payMethods, typesBilling, vehicles, reasons, operators]: [
          Residue[],
          Signs,
          PaymentMethod[],
          TypeBilling[],
          Vehicle[],
          Reason[],
          Operator[]
        ]) => {
          // Residues
          this.offlineSrv.saveToLocal('residues', residues);
          this.residues = residues;
          // Signs
          this.signatureImg = signs.path_sing_flume ?? '';
          this.offlineSrv.saveToLocal('signatureImg', this.signatureImg);
          // PaymentMethods
          this.offlineSrv.saveToLocal('payMethods', payMethods);
          this.payMethods = payMethods;
          // TypesBilling
          this.offlineSrv.saveToLocal('typesBilling', typesBilling);
          this.typesBilling = typesBilling;
          // Vehicles
          this.offlineSrv.saveToLocal('vehicles', vehicles);
          this.vehicles = vehicles;
          // Reasons
          this.offlineSrv.saveToLocal('reasons', reasons);
          this.reasons = reasons;
          // Operators
          this.offlineSrv.saveToLocal('operators', operators);
          this.operators = operators;
          this.initLoadInfo();
        },
        error: (error: { error: { detailed: string } }) => {
          let message = error.error.hasOwnProperty('detailed')
            ? error.error.detailed
            : 'No se pudo obtener la información de inicio.';
          this.no_internet &&
            (message += ' No cuenta con una conexión estable a internet.');
          this.toastSrv.error(message);
        },
      })
    );
  }

  private initLoadInfo(): void {
    this.residues.forEach((res) => {
      !this.categories.find((cat) => cat.label === res.category) &&
        this.categories.push({
          value: res.category_id,
          label: res.category!,
        });
    });

    this.typesBilOptions = [
      {
        value: -1,
        label: '---',
      },
      {
        value: 0,
        label: 'Sin especificar',
      },
    ];
    this.typesBilling.forEach((type) => {
      this.typesBilOptions.push({
        value: type.id!,
        label: type.description!,
      });
    });
    this.vehOptions = [
      {
        value: -1,
        label: '---',
      },
    ];
    this.vehicles.forEach((vehicle) => {
      this.vehOptions.push({
        value: vehicle.id!,
        label: vehicle.plate!,
      });
    });
    this.reasonOptions = [
      {
        value: -1,
        label: '---',
      },
    ];
    this.reasons.forEach((reason) => {
      this.reasonOptions.push({
        value: reason.id!,
        label: reason.description!,
      });
    });
    setTimeout(() => {
      this.onCancel();
      this.getCtrlPayForm('vehicle').setValue(this.card_info.vehicle?.id ?? -1);
      this.card_info.vehicle && this.getCtrlPayForm('vehicle').disable();
      this.onVehicleSelect();
      this.getCtrlPayForm('type_billing').setValue(
        this.card_info.pay_method
          ? this.card_info.pay_method?.type_billing_id ?? 0
          : -1
      );
      this.showPayMethods();
      this.getCtrlPayForm('pay_method').setValue(
        this.card_info.pay_method?.id ?? -1
      );
      this.onPayMethodSel();
      this.getCtrlPayForm('reason').setValue(-1);
      this.getCtrlPayForm('observations_gen').setValue(
        this.card_info.observations_ext ?? ''
      );
    });
    this.loading = false;
  }

  /**
   * Checks if the form is valid by ensuring 'aforosContent' is not empty and signatures are present.
   *
   * @private
   * @returns {boolean} True if the form is valid, otherwise false.
   */
  private isFormValid(): boolean {
    if (this.noWaste) {
      let reasonCtrl = this.getCtrlPayForm('reason');
      reasonCtrl.setErrors(reasonCtrl.value == '-1' ? { noValue: true } : null);
      reasonCtrl.markAsTouched();
      return reasonCtrl.valid;
    }
    if (this.gauges.length === 0 || !this.signatureImgSub) {
      return false;
    }
    return true;
  }

  /**
   * Reads a file asynchronously and returns a promise that resolves with the file data.
   *
   * @private
   * @param {any} file - The file to be read.
   * @returns {Promise<unknown>} A promise that resolves with the file data.
   */
  private readFileAsync(file: any): Promise<unknown> {
    return new Promise((resolve, reject) => {
      let reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  /**
   * Saves the form data if the form is valid. Uploads evidence files and signatures.
   *
   * @async
   * @returns {Promise<void>}
   */
  async save(): Promise<void> {
    let evidence_files: Array<{ file: string; name: string }> = [];
    let id = this.card_info.id;
    let img_flume = `${this.accountSrv.userValue?.username}.png`;
    let img_sub = `${
      this.card_info.subscriber?.niud || this.card_info.client?.identification
    }.png`;
    let data: any;
    if (this.isFormValid() && this.newEmail.valid) {
      this.save_btn = 'loading';
      for (let file in this.files) {
        let file_data = await this.readFileAsync(this.files[file]);
        evidence_files.push({
          file: file_data as string,
          name: this.files[file].name,
        });
      }
      data = {
        evidence: evidence_files,
        sign_flume: { file: this.signatureImg, name: img_flume },
        sign_subscriber: { file: this.signatureImgSub, name: img_sub },
        gauges: this.gauges.map((res) => {
          delete res.color;
          delete res.id;
          return res;
        }),
        total_costs: this.total,
        pay_method: this.payMethodSel?.id,
        new_client: this.card_info.client?.hasOwnProperty('is_new') ?? false,
      };
      this.payMethodSel?.id != -1 &&
        (data['pay_method'] = this.payMethodSel?.id);
      this.getCtrlPayForm('voucher').value &&
        (data['voucher'] = Number(this.getCtrlPayForm('voucher').value));
      this.getCtrlPayForm('installments').value &&
        (data['installments'] = Number(this.getCtrlPayForm('installments').value));
      this.getCtrlPayForm('subscribed_service').value &&
        (data['subscribed_service'] = Number(
          this.getCtrlPayForm('subscribed_service').value
        ));
      this.getCtrlPayForm('vehicle').value > -1 &&
        (data['vehicle'] = Number(this.getCtrlPayForm('vehicle').value));
      this.getCtrlPayForm('reason').value > -1 &&
        (data['reason'] = Number(this.getCtrlPayForm('reason').value));
      this.getCtrlPayForm('observations_gen').value &&
        (data['observations_gen'] = this.getCtrlPayForm('observations_gen').value);

      let microroute_id = this.offlineSrv.loadFromLocal('microroute_spe').value;
      if (!isNaN(microroute_id)) {
        data['microroute'] = Number(microroute_id);
      }

      this.newEmail.value && (data['new_email'] = this.newEmail.value);
      if (this.noWaste) {
        delete data['sign_subscriber'];
        data['gauges'] = [];
      }
      // in create mode
      if (!id) {
        this.card_info.subscriber
          ? (data['subscriber_id'] = this.card_info.subscriber.id)
          : (data['client_id'] = this.card_info.client?.id);
        data['flume_id'] = this.accountSrv.userValue?.id;
        data['date'] = dateTimeToString(new Date(), 'YYYY-MM-DD');
      }

      if (this.no_internet) {
        data['id'] = id;
        this.gaugings_pend = this.offlineSrv.loadFromLocal(
          'specials_to_create',
          []
        );
        this.gaugings_pend.push(data);
        this.offlineSrv.saveToLocal('specials_to_create', this.gaugings_pend);
        this.toastSrv.info('Aforo especial pendiente por crear.');
        this.router.navigateByUrl('/dashboard');
      } else {
        this.subscriptions.push(
          this.gaugingSrv.formSpecialGauge(data, id).subscribe({
            next: (result) => {
              this.save_btn = 'normal';
              this.toastSrv.success('Aforo especial creado correctamente.');
              setTimeout(() => {
                result.error_email && this.toastSrv.error(result.error_email);
              }, 3000);
              this.router.navigateByUrl('/dashboard');
            },
            error: (error: { error: { detailed: string } }) => {
              this.save_btn = 'normal';
              let message = error.error.hasOwnProperty('detailed')
                ? error.error.detailed
                : 'No se pudo guardar el aforo especial.';
              this.no_internet &&
                (message += ' No cuenta con una conexión estable a internet.');
              this.toastSrv.error(message);
            },
          })
        );
      }
    } else {
      this.error_sign_flume = true;
      !this.noWaste && (this.error_sign_sub = true);
      this.newEmail.markAsTouched();
    }
  }

  showPayMethods(): void {
    let payMethodsFiltered: Array<PaymentMethod> = [];
    let value = Number(this.getCtrlPayForm('type_billing').value);
    this.payOptions = [];
    if (value > 0) {
      payMethodsFiltered = this.payMethods.filter(
        (pay) => pay.type_billing_id == value
      );
    } else if (value === 0) {
      payMethodsFiltered = this.payMethods.filter(
        (pay) => !pay.type_billing_id
      );
    }
    this.payOptions = [
      {
        value: -1,
        label: '---',
      },
    ];
    payMethodsFiltered.forEach((pay) => {
      this.payOptions.push({
        value: pay.id!,
        label: pay.description!,
      });
    });

    this.getCtrlPayForm('pay_method').setValue(-1);
    this.onPayMethodSel();
  }

  showTable(): void {
    this.residueSel = this.residues.find(
      (w) => w.id == this.getControlOf('residue').value
    );
    if (!this.residueSel) {
      this.tablePrice = [{ td: ['0', '$0'] }];
      return;
    }
    this.tablePrice = [
      {
        td: [
          `1 ${this.residueSel.unit}`,
          `$${this.decimalPipe.transform(this.residueSel.price)}`,
        ],
      },
    ];
    let amount = Number(this.getControlOf('amount').value) || 0;
    if (amount != 0) {
      this.tablePrice.push({
        td: [
          `${amount} ${pluralize(this.residueSel.unit!, amount, [
            ['kg', 's'],
          ])}`,
          `$${this.decimalPipe.transform(
            this.residueSel.price! * amount,
            '1.0-0'
          )}`,
        ],
      });
    }
  }

  /**
   * Updates the paginator and sets the current page content.
   *
   * @param {any} page - The page number to set the paginator to.
   * @returns {void}
   */
  setPaginator(page: any): void {
    this.cards_page = this.cards_content.filter((card) => card.page === page);
    this.pageSelected = page;
  }
}

